import Exportar from "./Export";

export default Exportar;
